import { render, staticRenderFns } from "./ParcelEventHistoryModal.vue?vue&type=template&id=730e2636&"
import script from "./ParcelEventHistoryModal.vue?vue&type=script&lang=js&"
export * from "./ParcelEventHistoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports